import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'

const DIVIDER_COLOR = '#E2E8F0'
const SKIP_ROW_BG = '#F7F8FA'
const MUTED_TEXT_COLOR = '#6B7280'
const ERROR_RED = '#c1253a'
const ERROR_RED_BG = '#fff2f3'
const ERROR_BORDER = '#F8C5CD'
const SUCCESS_GREEN = '#17A871'
const SUCCESS_GREEN_BG = '#DBF1E5'
const SUCCESS_BORDER = '#86D9AE'
const FAIL_BG = '#FFECEF'
const FAIL_RED = '#D83148'
const PROGRESS_TRACK = '#9AC4E8'
const PROGRESS_FILL = '#006FC6'

const PILL_BORDER_RADIUS = 999
const ACTION_BUTTON_MIN_WIDTH = 108

export const useStyles = makeStyles((theme) => ({
    listRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1, 1.5),
        fontSize: pxToRem(14),
        borderBottom: `1px solid ${DIVIDER_COLOR}`,
        '&:last-child': { borderBottom: 'none' },
    },
    listRowSkip: {
        background: SKIP_ROW_BG,
        color: MUTED_TEXT_COLOR,
    },
    listRowFail: {
        background: ERROR_RED_BG,
        color: ERROR_RED,
    },
    listContainer: {
        marginTop: theme.spacing(1.5),
        border: `1px solid ${DIVIDER_COLOR}`,
        borderRadius: 6,
        overflow: 'hidden',
        listStyle: 'none',
        padding: 0,
    },
    skipNote: {
        fontSize: pxToRem(13),
        color: MUTED_TEXT_COLOR,
        marginTop: theme.spacing(0.5),
    },
    errorBox: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.25),
        padding: theme.spacing(1.5, 1.75),
        marginTop: theme.spacing(1.25),
        background: ERROR_RED_BG,
        border: `1px solid ${ERROR_BORDER}`,
        borderRadius: 6,
        fontSize: pxToRem(13),
        color: ERROR_RED,
        lineHeight: 1.5,
    },
    statusBadge: {
        fontSize: pxToRem(14),
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: PILL_BORDER_RADIUS,
    },
    statusSuccess: {
        background: SUCCESS_GREEN_BG,
        color: SUCCESS_GREEN,
        border: `1px solid ${SUCCESS_BORDER}`,
    },
    statusFail: {
        background: FAIL_BG,
        color: FAIL_RED,
        border: `1px solid ${ERROR_BORDER}`,
    },
    statusActive: {
        color: MUTED_TEXT_COLOR,
        fontSize: pxToRem(13),
    },
    statusInactive: {
        color: MUTED_TEXT_COLOR,
        fontSize: pxToRem(13),
    },
    cancelButton: {
        color: MUTED_TEXT_COLOR,
    },
    skipLabel: {
        fontSize: pxToRem(13),
    },
    progressContainer: {
        marginTop: pxToRem(14),
    },
    dialogTitle: {
        '& .MuiTypography-h6': {
            fontSize: pxToRem(18),
            fontWeight: 700,
        },
        '&.MuiDialogTitle-root': {
            padding: theme.spacing(3.125, 0, 2.5),
        },
    },
    dialogPaper: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    progressBar: {
        background: PROGRESS_TRACK,
        border: `1px solid ${PROGRESS_TRACK}`,
        boxSizing: 'border-box' as const,
        borderRadius: '100px',
        height: 10,
        '& .MuiLinearProgress-bar1Determinate': {
            background: PROGRESS_FILL,
            borderRadius: '100px',
        },
    },
    dialogContent: {
        '&.MuiDialogContent-root': {
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
        '& .MuiTypography-body2': {
            fontSize: pxToRem(14),
        },
        fontSize: pxToRem(14),
    },
    dialogActions: {
        '&.MuiDialogActions-root': {
            paddingLeft: 0,
            paddingRight: 0,
            boxShadow: 'none',
        },
        '& .MuiButtonBase-root': {
            fontSize: pxToRem(14),
            minWidth: ACTION_BUTTON_MIN_WIDTH,
            marginBottom: theme.spacing(0.5),
        },
    },
}))
